export default __webpack_public_path__ + "static/media/MO_Asset_Management_Logo.b4956ba3.webp";